<template>
  <div class="cycle_rule" v-if="clazz">
    <cycle-run-rule v-if="clazz.clazz_type==1" :clazz="clazz" />
    <cycle-cutting-rule v-if="clazz.clazz_type==2" :clazz="clazz" />
  </div>
</template>

<script>
import { clazzFullInfo } from '@/api/clazz'
import CycleRunRule from './components/cyclerule/CycleRunRule'
import CycleCuttingRule from './components/cyclerule/CycleCuttingRule'

export default {
  name: 'CycleRule',
  components: {
    CycleRunRule,
    CycleCuttingRule
  },
  data () {
    return {
      clazz: null
    }
  },
  created () {
    let clazzId = this.$route.params.clazz_id || ''
    this.getClazzInfo(clazzId)
  },
  methods: {
    async getClazzInfo (clazzId) {
      let response = await clazzFullInfo(clazzId)
      this.clazz = response.data
    }
  }
}
</script>

<style scoped lang="scss">
</style>
